import React from 'react';
import { connect } from 'react-redux';

import SuperAdminHome from './SuperAdminHome';
import AllevaRepHome from './AllevaRepHome';
import AdminHome from './AdminHome';
import UserHome from './UserHome';
import VisitorHome from './VisitorHome';

const userIsSuperAdmin = (userRole) => userRole === 'SuperAdmin';
const userIsAllevaRep = (userRole) => userRole === 'AllevaRep';
const userIsRegularAdmin = (userRole) => userRole === 'Admin';
const userIsRegularUser = (userRole) => userRole === 'User';

const haveLoggedInUser = (userRole) => {
  return (
    userIsRegularUser(userRole) ||
    userIsRegularAdmin(userRole) ||
    userIsAllevaRep(userRole) ||
    userIsSuperAdmin(userRole)
  );
};

const Home = (props) => {
  const { userRole } = props;
  return haveLoggedInUser(userRole) ? (
    userIsSuperAdmin(userRole) ? (
      <SuperAdminHome />
    ) : userIsAllevaRep(userRole) ? (
      <AllevaRepHome />
    ) : userIsRegularAdmin(userRole) ? (
      <AdminHome />
    ) : (
      <UserHome />
    )
  ) : (
    <VisitorHome />
  );
};

const mapStateToProps = (state) => ({ userRole: state.userInfo.role });
export default connect(mapStateToProps)(Home);
